// src/features/cms/cmsSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchCmsPage } from "./cmsThunks";

const cmsSlice = createSlice({
  name: "cms",
  initialState: {
    page: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCmsPage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCmsPage.fulfilled, (state, action) => {
        state.loading = false;
        state.page = action.payload;
      })
      .addCase(fetchCmsPage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default cmsSlice.reducer;
